import useParticipationController from "@customer/api/useParticipationController"
import useSalonPaymentController from "@customer/api/useSalonPaymentController"

export default function useApi(
    id: string | number,
    controller: Customer.Controllers.Salon
): Customer.Models.Salon.Api {
    const participate = () => controller.participate(id)
    
    const participationController = useParticipationController()
    const participation = {
        store: (sectionId: number, photoId: number) => participationController.store(id, sectionId, photoId),
        destroy: participationController.destroy
    }

    const payment = useSalonPaymentController(id)

    return {
        participate,
        participation,
        payment
    }
}